import type { UserFragment } from '../../user/user-data.graphql.generated';
import { RememberType } from 'approot/shared/signin/signin.constants';

export const USER_DATA_KEY = `userData:${process.env.REACT_APP_REGION}`;
export const SKIP_PATH_DATA_KEY = 'skipPath';
export const ALREADY_SIGNED_IN_KEY = `alreadySignedIn:${process.env.REACT_APP_REGION}`;
export const AUTH_HTTP_SOURCE_FILE = 'auth.http.tsx';

export type StorageUserData = {
  token: string;
  user: UserFragment;
  remember?: RememberType;
  skipChooseClassRedirectionPath?: string;
};
